import React, { useState } from 'react';
import ReactInterval from 'react-interval';
import { forgotPasswordEmail } from "../../store/action/user"
import { Button } from "../../components/buttons";

const ForgotPassword = () => {
    const [ values, setValues ] = useState({
        email:'',
        password:'',
        error:'',
        loading: false,
        redirectToReferrer: false,
        emailSent:false
    });

    const handleChange = name => event => {
        setValues({ ...values, error: false, [name]: event.target.value });
    };

    const onSubmit = async () => {
        try {
            const res = await forgotPasswordEmail(values.email);
            if (res.success) {
                setValues({...values, emailSent:true, loading:false});
            } else {
                setValues({...values, error:res.error, loading:false});
            }
        } catch (e) {
            console.log (e)
        }
    };

    const showError = () => (
        <div
            className="alert alert-danger"
            style={{display: values.error ? '' : 'none'}}
        >
            { values.error }
        </div>
    );

    const onLoading = e => {
        setValues({ ...values, loading:true})
    };

    if (values.emailSent){
        return (
            <div className="row">
                <div className="col-4"/>
                <div className="col-4">
                    <br/>
                    <br/>
                    <div className="card p-4 text-center">
                        <br/>
                        <div className="align-items-center">
                            <h2>
                                <img
                                    className="rounded-full" 
                                    style={{height:72}}
                                    src={"/images/logos/biteship.png"} 
                                    alt=""
                                />
                            </h2>
                        </div>
                        <br/>
                        <h6>
                            Kami sudah kirimkan link password ke email Anda. Mohon dicek.
                        </h6>
                        <br/>
                        <a href={`/`}>Kembali ke Menu Utama</a>
                    </div>
                </div>

            </div>
        )
    }

    return (
        <div className="row">
            <ReactInterval
                timeout={2000}
                enabled={values.loading}
                callback={() => onSubmit()}
            />
            <div className="col-4"/>
            <div className="col-4">
                <br/>
                <br/>
                <div className="align-items-center">
                    <h1 className="text-center">
                        <i>
                            <img
                                className="rounded-full" 
                                style={{height:72}}
                                src={"/images/logos/biteship.png"} 
                                alt=""
                            />
                        </i>
                    </h1>
                </div>

                <br/>

                <div className="card p-4">
                    <h4>
                        Lupa password?
                    </h4>
                    { showError() }
                    <p>Masukkan email Anda yang terhubung dengan akun Biteship lalu kami akan mengirimkan link perubahan password.</p>
                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Email address</label>
                        <input
                            type="text"
                            onChange={handleChange('email')}
                            placeholder="Email Anda"
                            className="form-control"
                            values={values.email}
                        />
                    </div>

                    <Button
                        onClick={() => setValues({...values, loading:true})}
                        loading={values.loading}
                        className="btn btn-primary btn-block"
                    >
                        {values.loading ? "Submitting..." : "Submit"}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
